import React, { useState } from "react";

import { MultiSelectDisplay, Money } from "../../components";
import { baseSymbol } from "../../core/currency";

// Sentence case: "case_material" → "Case material" (no ALL CAPS in the product).
const formatFilterName = (name) => {
  const words = name.split("_").join(" ").toLowerCase();
  return words.charAt(0).toUpperCase() + words.slice(1);
};

const formatAmount = (value) => {
  return parseInt(value).toLocaleString("uk", { maximumFractionDigits: 2 });
};

const formatFilterValue = (value) => {
  if (value?.substr(0, 6) === "range:") {
    const arr = value.substr(6).split("-");
    return baseSymbol() + formatAmount(arr[0]) + " - " + formatAmount(arr[1]);
  }

  return value;
};

const FilterBullets = ({ className = "", filters, onRemove }) => {
  const data = [];

  for (let filter in filters) {
    if (filter === "category_id") {
      continue;
    }

    let filterName = filter;

    if (filterName === "brand_id") {
      filterName = "Brand";
    }

    if (filterName === "model_id") {
      filterName = "Model";
    }

    for (let i = 0; i < filters[filter].length; i++) {
      const name =
        formatFilterName(filterName) +
        ": " +
        formatFilterValue(filters[filter][i].name);

      data.push({
        filter,
        id: filters[filter][i].id,
        name,
      });
    }
  }

  if (data.length === 0) {
    return <></>;
  }

  return (
    <MultiSelectDisplay
      options={data}
      onRemove={onRemove}
      className={`${className} search-bullets w-50`}
    />
  );
};

export default FilterBullets;
